module.exports = __webpack_public_path__ + "img/2.1a3ba0be.jpg";